import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

export function useAnnouncementOverviewLogic() {
	const { announcement } = useModuleData();
	const { config, loadModuleConfig } = useModuleConfig();

	const pageData = computed(() => {
		return (announcement.data?.data || []).slice(0, 3);
	});

	const isEmpty = computed(() => {
		return announcement.empty || !announcement.data?.data?.length;
	});

	const tabOption = computed(() => {
		return (config.value?.tab || []).sort((a, b) => a.sort - b.sort).filter(v => v.isPublish);
	});

	async function refresh(done) {
		await loadModuleConfig('announcement');
		if (tabOption.value.length) {
			let allTab = tabOption.value.find(v => v.id === 'announcement_all' && v.isPublish);
			let classificationIds;
			if (allTab) {
				classificationIds = '';
			} else {
				const allTabs = tabOption.value.flatMap(tab => [tab, ...(tab.subTabList || [])]);
				classificationIds = allTabs.map(v => v.id.slice(11).replace(/,/g, '#')).join(',');
			}
			await announcement.refresh({
				pageStart: 0,
				pageNum: 20,
				classificationIds
			});
		} else {
			announcement.loading = false;
		}

		done && done();
	}

	return {
		announcement,
		pageData,
		isEmpty,
		refresh
	};
}
